import { freeze } from "immer";

export const RecipeTab = freeze(
  {
    General: "general",
    Ingredients: "ingredients",
    Nutrition: "nutrition",
    Label: "label",
    Photos: "photos",
    UsedAsSubRecipe: "used-as-sub-recipe",
  } as const,
  true,
);
